export const categories = [
    "Team Documents",
    "Customers & Partners",
    "Sales & Marketing",
    "Financials",
    "Market & Competition",
    "Product & Technology",
    "Legal",
    "Other"
]